<template>
  <form>
    <div class="input-group " style="z-index: 1">
      <b-input-group size="sm" prepend="Problem">
        <b-form-textarea id="textarea1" v-model="ticketForm.description" :rows="3" :max-rows="3">
        </b-form-textarea>
        <b-btn class="submitButton blue-background" @click="submitForm">
          <icon name="paper-plane" scale="1.8"></icon>
        </b-btn>
      </b-input-group>
    </div>
  </form>
</template>

<script>
export default {
  name: "Ticket_Form",
  props: {},
  data() {
    return { ticketForm: { description: "" } };
  },
  methods: {
    submitForm: function() {
      this.$emit("createnewticket", this.ticketForm.description);
      this.ticketForm.description = "";
    }
  },
  created() {},
  destroyed() {}
};
</script>
<style scoped>
.submitButton {
  min-width: 70px;
  background-color: #4b93bb;
}
.submitButton:hover {
  background-color: #3f7b9b;
}
</style>



// WEBPACK FOOTER //
// src/components/Form/TicketForm.vue